import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { Col, Row, Container } from "reactstrap";
import { v4 } from "uuid";

const CommentsCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [workTime, setWorkTime] = useState({});

	const dispatch = useDispatch();

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة موعد جديد",
				breadcrumb: "مواعيد العمل",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	useEffect(() => {
		onStart();
	}, []);

	const handleSubmit = e => {
		e.preventDefault();
		if (
			// picture.placeholder ||
			!workTime.day.ar ||
			!workTime.time.ar ||
			!workTime.day.en ||
			!workTime.time.en
		) {
			toast.warn("الرجاء ادخال جميع البيانات المطلوبة");
			return;
		}
		const data = {
			...workTime,
			title: "workTime",
		};
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/pages/work-times/sections`,
				{
					section: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(
				_ =>
					toast.success("تم اضافة الموعد بنجاح") && history.push("/times/index")
			)
			.catch(_ => toast.error("حدث خطا !"));
	};

	return (
		<section>
			<Container>
				<div className="card">
					<div className="card-body">
						<Row style={{ marginTop: "2rem" }}>
							<Col>
								<div className="form-item">
									<label htmlFor="dayAr">اليوم بالعربية</label>

									<input
										type="text"
										id="dayAr"
										name="dayAr"
										onChange={e => {
											setWorkTime({
												...workTime,
												day: { ...workTime.day, ar: e.target.value },
											});
										}}
									/>
								</div>
							</Col>

							<Col>
								<div className="form-item">
									<label htmlFor="dayEn"> اليوم بالانجليزية</label>

									<input
										type="text"
										id="dayEn"
										name="dayEn"
										onChange={e => {
											setWorkTime({
												...workTime,
												day: { ...workTime.day, en: e.target.value },
											});
										}}
									/>
								</div>
							</Col>
						</Row>
						<Row>
							<Col>
								<div className="form-item">
									<label htmlFor="timeAr">الموعد بالعربية</label>

									<input
										type="text"
										id="timeAr"
										name="jobNameAR"
										onChange={e => {
											setWorkTime({
												...workTime,
												time: { ...workTime.time, ar: e.target.value },
											});
										}}
									/>
								</div>
							</Col>

							<Col>
								<div className="form-item">
									<label htmlFor="time"> الموعد بالانجليزية </label>

									<input
										type="text"
										id="time"
										name="jobNameEN"
										onChange={e => {
											setWorkTime({
												...workTime,
												time: { ...workTime.time, en: e.target.value },
											});
										}}
									/>
								</div>
							</Col>
						</Row>

						<Row>
							<Col>
								<div className="form-item mt-3">
									<button
										className="bt bt-success btn-block"
										onClick={handleSubmit}
									>
										ارسال
									</button>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		</section>
	);
};

export default CommentsCreate;
